export enum Operations {
  Add = 1,
  Edit = 2,
  Delete = 3,
  Read = 4
}